export function msToHMS( ms ) {
    // 1- Convert to seconds:
    let seconds =ms / 1000;
    // 2- Extract hours:
    const h = parseInt( seconds / 3600 ); // 3,600 seconds in 1 hour
    seconds = seconds % 3600; // seconds remaining after extracting hours
    // 3- Extract minutes:
    const m = parseInt( seconds / 60 ); // 60 seconds in 1 minute
    // 4- Keep only seconds not extracted to minutes:
    seconds = seconds % 60;

    var hDisplay = h > 0 ? h + (h == 1 ? " h " : " h ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
    var sDisplay = seconds > 0 ? seconds.toFixed(1) + (seconds == 1 ? " s" : " s") : "";
    return hDisplay + mDisplay + sDisplay; 
}